export default __webpack_public_path__ + "static/Abbott-Website-loop-home-lead-1400x680-dbb095d06c7d9241d2cf1b3f0494bdbd.mp4";